import { useGetToGroupInstructionAction } from '../../../actions/drop-down-actions/AddToGroupInstructionAction';
import { useSaveToMyResourceAction } from '../../../actions/drop-down-actions/AddToMyResourceAction';
import { useDetailPlanLinkAction } from '../../../actions/drop-down-actions/detail-plan-link-action/DetailPlanLinkAction';
import { Lesson } from '../../../types/lesson/LessonType';

type TopicsDropdownMenuParams = {
  topicId?: string;
  /** Instruction level currently being viewed, if any */
  level?: string;
  /** Lessons of the level currently being viewed */
  lessons: Lesson[];
};

export const useGetTopicsDropdownMenu = () => {
  const { getAddToGroupInstructionAction } = useGetToGroupInstructionAction({});
  const { getSaveToMyResourceAction } = useSaveToMyResourceAction();
  const { getTopicDetailPlanLinkAction } = useDetailPlanLinkAction();

  const getTopicsDropdownMenu = ({ topicId, level, lessons }: TopicsDropdownMenuParams) => {
    // Actions that operate on the leveled lessons are only available once a level is chosen
    const lessonActions = lessons.length > 0
      ? [getAddToGroupInstructionAction(lessons), getSaveToMyResourceAction(lessons)]
      : [];
    const linkActions = topicId ? [getTopicDetailPlanLinkAction(topicId, level)] : [];
    return [...lessonActions, ...linkActions];
  };

  return {
    getTopicsDropdownMenu,
  };
};
